function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconStars = function SvgIconStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.96921 1.80812C5.21905 1.17464 6.11558 1.17464 6.36542 1.80812L7.13966 3.77122C7.21594 3.96463 7.36903 4.11772 7.56244 4.194L9.52554 4.96823C10.159 5.21808 10.159 6.11461 9.52554 6.36445L7.56244 7.13868C7.36903 7.21496 7.21594 7.36806 7.13966 7.56146L6.36542 9.52456C6.11558 10.158 5.21905 10.158 4.96921 9.52456L4.19497 7.56146C4.1187 7.36806 3.9656 7.21496 3.7722 7.13868L1.80909 6.36445C1.17561 6.11461 1.17562 5.21808 1.8091 4.96823L3.7722 4.194C3.9656 4.11772 4.1187 3.96463 4.19497 3.77122L4.96921 1.80812Z",
    fill: "#3756FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2824 8.92809C11.4197 8.57996 11.9124 8.57996 12.0497 8.92809L12.6501 10.4506C12.692 10.5568 12.7762 10.641 12.8825 10.6829L14.4049 11.2833C14.753 11.4206 14.753 11.9133 14.4049 12.0506L12.8825 12.6511C12.7762 12.693 12.692 12.7771 12.6501 12.8834L12.0497 14.4059C11.9124 14.754 11.4197 14.754 11.2824 14.4059L10.6819 12.8834C10.64 12.7771 10.5559 12.693 10.4496 12.6511L8.92711 12.0506C8.57898 11.9133 8.57898 11.4206 8.92711 11.2833L10.4496 10.6829C10.5559 10.641 10.64 10.5568 10.6819 10.4506L11.2824 8.92809Z",
    fill: "#3756FB"
  }));
};
export default SvgIconStars;